import types from '../types/paymentMethod'
import startTypes from '../types/start'
import {Map, List} from 'immutable'
import orchestratorTypes from '../types/orchestrator'

const initialCards = List()

function cards(state = initialCards, action) {
  switch (action.type) {
    case types.FETCH_SUCCESS:
      return List(action.payload.cards)
    case types.SAVE_SUCCESS:
      return state.push(action.payload.card)
    case orchestratorTypes.START:
      return initialCards
    default:
      return state
  }
}

const initialAdd = Map({
  number: '',
  expiry: '',
  cvc: '',
  cardholderName: '',
  documentType: '',
  documentNumber: '',
})

function add(state = initialAdd, action) {
  switch (action.type) {
    case types.SET_NUMBER:
      return state.set('number', action.payload.value)
    case types.SET_EXPIRY:
      return state.set('expiry', action.payload.value)
    case types.SET_CVC:
      return state.set('cvc', action.payload.value)
    case types.SET_CARDHOLDER_NAME:
      return state.set('cardholderName', action.payload.value)
    case types.SET_DOCUMENT_TYPE:
      return state.set('documentType', action.payload.value)
    case types.SET_DOCUMENT_NUMBER:
      return state.set('documentNumber', action.payload.value)
    case orchestratorTypes.START:
      return initialAdd
    default:
      return state
  }
}

const initialRoot = Map({
  documentTypes: List(),
  tab: 0,
  selected: 0,
  isFetching: false,
  isSaving: false,
  isModifying: false,
  error: '',
})

function root(state = initialRoot, action) {
  switch (action.type) {
    case types.FETCH_DOCUMENT_TYPES_SUCCESS:
      return state.merge({
        documentTypes: List(action.payload.documentTypes),
        error: '',
      })
    case types.SET_TAB:
      return state.set('tab', action.payload.tab)
    case startTypes.GET_TRANSACTION_SUCCESS:
      return state.set('selected', action.payload.transaction.Card.ID)
    case types.FETCH:
      return state.merge({
        isFetching: true,
        error: '',
      })
    case types.FETCH_SUCCESS:
      return state.merge({
        isFetching: false,
        error: '',
      })
    case types.FETCH_FAIL:
      return state.merge({
        isFetching: false,
        error: action.payload.error,
      })
    case types.SAVE:
      return state.merge({
        isSaving: true,
        error: '',
      })
    case types.SAVE_SUCCESS:
      return state.merge({
        selected: action.payload.card.ID,
        isSaving: false,
        error: '',
      })
    case types.SAVE_FAIL:
      return state.merge({
        isSaving: false,
        error: action.payload.error,
      })
    case types.SET_SELECTED:
      return state.set('selected', action.payload.selected)
    case types.MODIFY_TRANSACTION:
      return state.merge({
        isModifying: true,
        error: '',
      })
    case types.MODIFY_TRANSACTION_SUCCESS:
      return state.merge({
        isModifying: false,
        error: '',
        tab: 0,
      })
    case types.MODIFY_TRANSACTION_FAIL:
      return state.merge({
        isModifying: false,
        error: action.payload.error,
      })
    case orchestratorTypes.START:
      return initialRoot
    default:
      return state
  }
}

export default function(state, action) {
  const m = Map({
    cards: cards(state ? state.get('cards') : undefined, action),
    add: add(state ? state.get('add') : undefined, action),
  })
  return root(state, action).merge(m)
}



// WEBPACK FOOTER //
// ./src/sections/remove/reducers/paymentMethod.js